import { Box, Typography } from '@mui/material';

type EmptyStateProps = {
  /** Vad som saknas, till exempel "Ingen fakturamottagare". */
  text: string;
};

/**
 * Tomtillstånd för ett avsnitt som saknar data.
 *
 * En grå textrad flyter ihop med innehållet runt omkring och ser ut som en uppgift bland
 * andra. Ett svagt tonat fält bryter av i stället, så att det går att se på en halv sekund
 * att avsnittet är tomt och inte att man missat något.
 *
 * Full bredd och centrerad text, så att det läses som en platshållare och inte som ett värde.
 */
export const EmptyState = (props: EmptyStateProps) => {
  const { text } = props;

  return (
    <Box
      sx={{
        width: '100%',
        py: 2,
        px: 2,
        borderRadius: 1,
        backgroundColor: 'grey.50',
        color: 'text.secondary',
        textAlign: 'center',
      }}
    >
      <Typography variant='body2'>{text}</Typography>
    </Box>
  );
};
